<template>
	<div class="jiedaiOrder">
		<div class="radioBox">
			<el-radio-group v-model="radio" @change="changeRadio">
				<el-radio :label="0">全部</el-radio>
				<!-- <el-radio :label="6">待结算</el-radio> -->
				<el-radio :label="1">住院中</el-radio>
				<el-radio :label="2">已完成</el-radio>
				<!-- <el-radio :label="9">已取消</el-radio> -->
			</el-radio-group>
		</div>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column label="状态" width="60">
				<template slot-scope="props">
					<div v-if="props.row.payInfo.payCount===0">
						<div style="color:red">未支付</div>
					</div>
					<div v-else>
						<div style="color:#18A44C">{{props.row.status==1?'住院中':''}}</div>
						<div style="color:#B7B7B7">{{props.row.status==2?'已离院':''}}</div>
					</div>
				</template>
			</el-table-column> 
			<el-table-column label="状态" width="45">
				<template slot-scope="props">
					<span v-if="props.row.consumeMoney>props.row.deposit" style="color:red">已欠费</span>
					<span v-else>
						<span v-if="props.row.payInfo&&props.row.payInfo.payCount==0" style="color:#B05B12">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
						<span v-if="props.row.payInfo&&props.row.payInfo.payCount>0" style="color:#18A44C">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" width="120">
				<template slot-scope="props">
					<div>{{$public.FTime(props.row.createTime,'YYYY/MM/DD HH:mm')}}</div>
				</template>
			</el-table-column>
			<el-table-column label="顾客" prop="memberName">
			</el-table-column>
			<el-table-column label="宠物" prop="petName">
			</el-table-column>
			<el-table-column label="品种" prop="typeName" width="60">
			</el-table-column>
			<el-table-column label="年龄" prop="birthDay" width="60">
				<template slot-scope="props">
					<div v-if="props.row.birthDay&&props.row.birthDay.length>4">
						{{$public.FAge(new Date(props.row.birthDay).getTime())[0]}}年{{$public.FAge(new Date(props.row.birthDay))[1]}}月
					</div>
				</template>
			</el-table-column>
			<el-table-column label="经办人" width="70">
				<template slot-scope="props">
					<div>{{props.row.handlerName}}</div>
				</template>
			</el-table-column>
			<el-table-column label="时间" width="145">
				<template slot-scope="props">
					<div>{{$public.FTime(props.row.beginDate,'YYYY/MM/DD')}}-{{$public.FTime(props.row.endDate,'YYYY/MM/DD')}}</div>
				</template>
			</el-table-column>
			<el-table-column label="时长" width="70">
				<template slot-scope="props">
					<div>{{props.row.inHospitalDuration}}</div>
				</template>
			</el-table-column>
			<el-table-column label="住院单号" prop="id" width="90">
				<template slot-scope="props">
					<span >{{props.row.id}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="90">
				<template slot-scope="props">
					<el-button type="text" size="mini" @click="toZhuyuanSee(props.row)">查看</el-button>
					<el-button v-if="props.row.status==1&&props.row.payInfo.payCount>0" type="text" size="medium" @click="leave(props.row)">离院</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBox">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :orderId="curOrder._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import page from "../../../../../components/page.vue"
	import dialogSettlement from "../../../../../components/dialog_settlement.vue"
	export default {
		components:{page,dialogSettlement},
		data(){
			return{
				radio:0,
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// 结算
				dialogSettlementState: false,
				curOrder: {},
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// changeRadio
			changeRadio(){
				this.page.page=1;
				this.getTableData();
			},
			// 查看
			toZhuyuanSee(row){
				this.$router.push({path:"/yiliao/zhuyuanSee?id="+row.id})
			},
			// 结算
			pay(row) {
				this.curOrder = row
				this.dialogSettlementState = true;
			},
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if (a == 'close') {
					console.log(a)
				} else if (a == 'fail') {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				} else if (a == 'success') {
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
				this.getTableData();
			},
			// 离院
			leave(row){
				this.$confirm('确定要离院?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/InHospital/Leave', {inHospitalId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '离院成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			changePage(num){
				this.page.page=num;
				this.getTableData();
			},
			// 获取列表数据
			getTableData() {
				let curDay = this.$public.FTime(new Date().getTime(),'YYYY-MM-DD')
				let params = {
					"keyword":'',
					// "petId": this.curPetId,
					"memberId": "",
					"status": this.radio, // 0不限；1：住院中；2：已离院
					isPay:-1,  // （-1不限：0未支付；1：已支付）
					"depositType": 0,  // (0不限；1：押金；2：余额)
					startTime: ('' + (new Date(curDay).getTime()-28800000)).substr(0, 10),  //开始时间
					endTime: ('' + (new Date(curDay).getTime()+86400000-28800000)).substr(0, 10),	//结束时间
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				// if(this.datetimerange&&this.datetimerange.length==2){
				// 	params.begin_time=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
				// 	params.end_time=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				// }
				console.log(params)
				let loading=this.$loading();
				this.$http.post('/api/InHospital/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.jiedaiOrder{
	width:100%;height: 100%;padding-bottom:50px;box-sizing: border-box;padding-top:40px;position: relative;
	.radioBox{
		padding:12px 30px 12px;position: absolute;z-index: 1;top:0;width:100%;box-sizing: border-box;
	}
	.pageBox{
		// padding:20px;
	}
}
</style>
